/* eslint-disable */
const i18n = {
  "en-US": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "Free Trial",
          "upgrade": "Upgrade"
        }
      }
    }
  },
  "de-DE": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "Kostenloser Test",
          "upgrade": "Upgrade"
        }
      }
    }
  },
  "es-ES": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "Prueba gratuita",
          "upgrade": "Actualizar"
        }
      }
    }
  },
  "fr-FR": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "Essai gratuit",
          "upgrade": "Surclasser"
        }
      }
    }
  },
  "id-ID": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "Uji Coba Gratis",
          "upgrade": "Tingkatkan"
        }
      }
    }
  },
  "it-IT": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "Prova gratuita",
          "upgrade": "Effettua l\u2019upgrade"
        }
      }
    }
  },
  "jp-JP": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "\u7121\u6599\u30C8\u30E9\u30A4\u30A2\u30EB",
          "upgrade": "\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9"
        }
      }
    }
  },
  "ko-KO": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "\uBB34\uB8CC \uC2DC\uD5D8\uD310",
          "upgrade": "\uC5C5\uADF8\uB808\uC774\uB4DC"
        }
      }
    }
  },
  "nl-NL": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "Gratis proefversie",
          "upgrade": "Upgraden"
        }
      }
    }
  },
  "pl-PL": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "Bezpłatna wersja testowa",
          "upgrade": "Zaktualizuj"
        }
      }
    }
  },
  "pt-PT": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "Teste gr\u00E1tis",
          "upgrade": "Fazer upgrade"
        }
      }
    }
  },
  "ru-RU": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "\u0411\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u0430\u044F \u043F\u0440\u043E\u0431\u043D\u0430\u044F \u0432\u0435\u0440\u0441\u0438\u044F",
          "upgrade": "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0431\u043E\u043B\u0435\u0435 \u0432\u044B\u0441\u043E\u043A\u0438\u0439 \u043F\u043B\u0430\u043D"
        }
      }
    }
  },
  "tr-TR": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "Ücretsiz Deneme",
          "upgrade": "Y\u00FCkselt"
        }
      }
    }
  },
  "vi-VN": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "D\u00F9ng th\u1EED mi\u1EC5n ph\u00ED",
          "upgrade": "N\u00E2ng c\u1EA5p"
        }
      }
    }
  },
  "zh-CN": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "\u514D\u8D39\u8BD5\u7528",
          "upgrade": "\u5347\u7EA7"
        }
      }
    }
  },
  "zh-TW": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "\u514D\u8CBB\u8A66\u7528",
          "upgrade": "\u5347\u7D1A"
        }
      }
    }
  },
  "sv-SE": {
    "billing": {
      "product": {
        "entry_free_trial": {
          "buy": "Gratis provperiod",
          "upgrade": "Uppgradera"
        }
      }
    }
  }
}
export default i18n
